import "./Contact.css";

const Aboutus = () => {
  return (
    <div className="form-container">
      <h3>About Us</h3>
      <p className="text-left">
        {/* <center>Already a user? <Link to="/signin">sign in</Link></center> */}
        Pellentesquemalesuada fames ac turpis egestas. Vestibulum tortor quam,
        feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero
        sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris
        placerat eleifend leo. Pellentesque habitant morbi tristique senectus et
        netus et malesuada fames ac turpis egestas. Vestibulum tortor quam,
        feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero
        sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris
        placerat eleifend leo. Pellentefeugiat vitae, ultricies eget, tempor sit
        amet, ante. Donec eu libero sit amet quam egestas semper. Aenean
        ultricies mi vitae est. Mauris placerat eleifend
        leo.Pellentesquemalesuada fames ac turpis egestas. Vestibulum tortor
        quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu
        libero sit amet quam egestas semper. Aenean ultricies mi vitae est.
        Mauris placerat eleifend leo. Pellentesque habitant morbi tristique
        senectus et netus et malesuada fames ac turpis egestas. Vestibulum
        tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec
        eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est.
        Mauris placerat eleifend leo. Pellentefeugiat vitae, ultricies eget,
        tempor sit amet, ante. Donec eu libero sit amet quam egestas semper.
        Aenean ultricies mi vitae est. Mauris placerat eleifend leo.
      </p>
    </div>
  );
};

export default Aboutus;